export enum WORK_STATUS {
  PRISTINE = "pristine",
  TOUCHED = "touched",
  COMPLETE = "complete",
}

export type WORK_STATUS_SIMPLE = WORK_STATUS.TOUCHED | WORK_STATUS.COMPLETE; // FIXME: incomplete/complete
